import {
  createRentalApplication,
  getRentalApplications,
  getRentalApplication,
} from '@/api/calls/rentalApplication';
import { RentalApplicationFilters } from '@/api/types/rentalApplication';
import { errorToast } from '@/api/utils';
import { useMutation, useQuery } from '@tanstack/react-query';

// Custom hook for the mutation
export const useCreateRentalApplication = () => {
  return useMutation({
    mutationFn: createRentalApplication,
    onError: (_error: Error) => {
      errorToast();
    },
  });
};

// Custom hook for fetching rental applications
export const useGetRentalApplications = (filters?: RentalApplicationFilters) => {
  return useQuery({
    queryKey: ['rental-applications', filters],
    queryFn: () => getRentalApplications(filters),
  });
};

// Custom hook for fetching a single rental application
export const useGetRentalApplication = (id: string) => {
  return useQuery({
    queryKey: ['rental-application', id],
    queryFn: () => getRentalApplication(id),
    enabled: !!id, // Only run query if id is provided
  });
};
